import { hFetch } from '@/lib/hfetch';
import type { PipelineReviewConfigurationEntity } from '@/api/entity_types/pipeline_review/Configuration';

export const getConfigurations = async () => {
  return await hFetch<PipelineReviewConfigurationEntity[]>({
    url: '/api/pipeline_review/configurations',
  });
};

export const updateConfiguration = async (id: number, params: Partial<PipelineReviewConfigurationEntity>) => {
  return await hFetch({
    url: `/api/pipeline_review/configurations/${id}`,
    method: 'PUT',
    payload: { pipeline_review_configuration: params },
  });
};
